import { CommonModule } from '@angular/common';
import { HttpClient } from '@angular/common/http';
import { Injectable, NgModule } from '@angular/core';
import { JsonResourceResponse } from 'app/generated/generated-common';
import { Observable, throwError } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { CurrencyLookupModel } from 'app/generated/backend/currency/api/currency-lookup-model';

@Injectable()
export class CurrencyLookupHandlerService {
	private handleError(error: Response | any) {
		return throwError(error);
	}
	constructor(private http: HttpClient) { }
	get(
	): Observable<JsonResourceResponse<CurrencyLookupModel[]>> {
		return this.http.get<JsonResourceResponse<CurrencyLookupModel[]>>('api/v1/currency/currencies').pipe(
			map(response => response),
			catchError(this.handleError));
	}
}

@NgModule({
	imports: [
		CommonModule
	],
	providers: [
		CurrencyLookupHandlerService
	]
})
export class CurrencyLookupHandlerModule { }
